import React from "react";
import withHeader from "../hocs/withHeader";
import {connect} from "react-redux";

function PageNotFound(props) {
    const onClickButton = (e) => {
        e.preventDefault();
        if (props.isUserLoggedIn) {
            props.history.push('/surveys');
        } else {
            window.location = '/';
        }
    }

    return (
        <div className="page_not_found_container fullscreen">
            <div className="page_not_found_image"></div>
            <h1>Oops, you have reached a dead end</h1>
            <p>Go back on the route from questions to insights</p>
            <a className="modal-content__actions__btn" onClick={onClickButton}>Take me home</a>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
};

export default connect(mapStateToProps)(withHeader(PageNotFound));